import type { IconProps } from "@obs/icons";
import { measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement } from "react";

export type IconButtonPrimitiveProps = {
	Component: (props: IconProps) => ReactElement;
	isLoading?: boolean;
} & Omit<IconProps, "size" | "iconColor">;

const styles = stylex.create({
	root: {
		display: "inline-flex",
		flexShrink: 0,
		width: measure.sizeIconDefault,
		height: measure.sizeIconDefault,
	},
});

export function IconButtonPrimitive({ Component, isLoading, ...props }: IconButtonPrimitiveProps) {
	return <Component {...props} {...stylex.props(styles.root)} iconColor={isLoading ? "transparent" : "currentColor"} />;
}
